export default "https://cdn-static.gokick.com/assets/a6d011c942efc1c6cd2854aca00adc3db9e08265/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";